import { render, staticRenderFns } from "./BlockDetails.vue?vue&type=template&id=da5a48b2&scoped=true"
import script from "./BlockDetails.vue?vue&type=script&lang=js"
export * from "./BlockDetails.vue?vue&type=script&lang=js"
import style0 from "./BlockDetails.vue?vue&type=style&index=0&id=da5a48b2&prod&scoped=true&lang=css"
import style1 from "./BlockDetails.vue?vue&type=style&index=1&id=da5a48b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5a48b2",
  null
  
)

export default component.exports